var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-form',{attrs:{"schema":_vm.schema,"nestable":false},scopedSlots:_vm._u([{key:"default",fn:function({ fields }){return [_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('dv-form-field',{attrs:{"field":fields.options}})],1)],1)]}}]),model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }